import React from 'react';
import Icon from './Icon';

/** Stepper — numbered progress steps. steps: string[]; current: 0-based index */
export default function Stepper({ steps, current = 0, className = '' }) {
  return (
    <ol className={`stepper${className ? ` ${className}` : ''}`}>
      {steps.map((label, i) => {
        const state = i < current ? 'is-done' : i === current ? 'is-current' : '';
        return (
          <li key={label} className={`stepper__step${state ? ` ${state}` : ''}`} aria-current={i === current ? 'step' : undefined}>
            <span className="stepper__dot">{i < current ? <Icon name="check" size={14} strokeWidth={2.4} /> : i + 1}</span>
            <span className="stepper__label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
